var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundsCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 454,
    viewBox: "0 0 445 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07897 376.053C8.19273 384.703 11.6622 394.52 13.9971 404.321C14.474 405.16 14.9837 405.982 15.4934 406.804C12.9612 395.211 8.91625 383.437 2.53638 373.422C2.70081 374.31 2.89812 375.181 3.09543 376.053H3.07897Z",
    fill: "url(#paint0_linear_935_11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07897 376.053C8.19273 384.703 11.6622 394.52 13.9971 404.321C14.474 405.16 14.9837 405.982 15.4934 406.804C12.9612 395.211 8.91625 383.437 2.53638 373.422C2.70081 374.31 2.89812 375.181 3.09543 376.053H3.07897Z",
    fill: "url(#paint1_linear_935_11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.859232 358.622C15.9703 374.376 21.8898 398.549 24.0602 418.644C24.4055 419.055 24.7508 419.45 25.0961 419.845C23.0079 399.042 16.9569 373.52 0.842773 357.273C0.842773 357.717 0.842755 358.178 0.875641 358.622H0.859232Z",
    fill: "url(#paint2_linear_935_11)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.859232 358.622C15.9703 374.376 21.8898 398.549 24.0602 418.644C24.4055 419.055 24.7508 419.45 25.0961 419.845C23.0079 399.042 16.9569 373.52 0.842773 357.273C0.842773 357.717 0.842755 358.178 0.875641 358.622H0.859232Z",
    fill: "url(#paint3_linear_935_11)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56494 350.761C4.83843 349.1 3.02969 347.555 1.15519 346.124C1.12231 346.486 1.10588 346.864 1.073 347.226C2.75018 348.541 4.378 349.923 5.92364 351.419C6.20317 351.682 6.46626 351.945 6.74579 352.225C26.28 371.761 30.9005 404.913 31.6569 426.735C31.9693 427.031 32.2817 427.327 32.5941 427.623C31.9364 405.686 27.4146 371.629 7.38709 351.6C7.124 351.337 6.84447 351.057 6.56494 350.794V350.761Z",
    fill: "url(#paint4_linear_935_11)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56494 350.761C4.83843 349.1 3.02969 347.555 1.15519 346.124C1.12231 346.486 1.10588 346.864 1.073 347.226C2.75018 348.541 4.378 349.923 5.92364 351.419C6.20317 351.682 6.46626 351.945 6.74579 352.225C26.28 371.761 30.9005 404.913 31.6569 426.735C31.9693 427.031 32.2817 427.327 32.5941 427.623C31.9364 405.686 27.4146 371.629 7.38709 351.6C7.124 351.337 6.84447 351.057 6.56494 350.794V350.761Z",
    fill: "url(#paint5_linear_935_11)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5831 344.545C9.44246 341.618 6.05517 339.086 2.42128 336.882C2.3555 337.195 2.32261 337.523 2.25684 337.836C5.7263 339.974 8.96557 342.407 11.9746 345.203C12.4844 345.68 12.9941 346.173 13.4874 346.667C35.1099 368.291 38.3985 406.344 38.3985 427.409C38.3985 429.119 38.3656 430.83 38.3327 432.54C38.6287 432.77 38.9247 433 39.2206 433.231C39.27 431.29 39.3029 429.35 39.3029 427.426C39.3029 406.229 35.9814 367.913 14.1287 346.042C13.6189 345.532 13.1092 345.039 12.5831 344.562V344.545Z",
    fill: "url(#paint6_linear_935_11)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5831 344.545C9.44246 341.618 6.05517 339.086 2.42128 336.882C2.3555 337.195 2.32261 337.523 2.25684 337.836C5.7263 339.974 8.96557 342.407 11.9746 345.203C12.4844 345.68 12.9941 346.173 13.4874 346.667C35.1099 368.291 38.3985 406.344 38.3985 427.409C38.3985 429.119 38.3656 430.83 38.3327 432.54C38.6287 432.77 38.9247 433 39.2206 433.231C39.27 431.29 39.3029 429.35 39.3029 427.426C39.3029 406.229 35.9814 367.913 14.1287 346.042C13.6189 345.532 13.1092 345.039 12.5831 344.562V344.545Z",
    fill: "url(#paint7_linear_935_11)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5847 338.313C14.2767 334.448 9.52465 331.275 4.27935 328.693C4.19713 328.989 4.11493 329.285 4.03271 329.581C9.14648 332.097 13.7834 335.205 17.9764 338.987C41.5885 360.168 45.025 399.717 44.9921 421.407C44.9921 426.603 44.7619 431.816 44.4166 437.013C44.7126 437.21 44.9921 437.424 45.2881 437.621C45.6499 432.227 45.88 426.817 45.8965 421.407C45.9294 400.259 42.6737 362.272 20.8374 340.451C20.0975 339.711 19.3576 339.004 18.5683 338.313H18.5847Z",
    fill: "url(#paint8_linear_935_11)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5847 338.313C14.2767 334.448 9.52465 331.275 4.27935 328.693C4.19713 328.989 4.11493 329.285 4.03271 329.581C9.14648 332.097 13.7834 335.205 17.9764 338.987C41.5885 360.168 45.025 399.717 44.9921 421.407C44.9921 426.603 44.7619 431.816 44.4166 437.013C44.7126 437.21 44.9921 437.424 45.2881 437.621C45.6499 432.227 45.88 426.817 45.8965 421.407C45.9294 400.259 42.6737 362.272 20.8374 340.451C20.0975 339.711 19.3576 339.004 18.5683 338.313H18.5847Z",
    fill: "url(#paint9_linear_935_11)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6028 332.08C19.2917 327.476 13.3558 323.907 6.61418 321.211C6.51552 321.49 6.40042 321.77 6.30176 322.066C12.9283 324.713 18.7819 328.249 24.0108 332.771C49.1357 354.544 51.6843 397.826 51.6021 415.421C51.5692 423.824 50.9937 432.277 50.2209 440.663C50.5004 440.828 50.7964 440.976 51.0924 441.14C51.8816 432.606 52.4736 423.989 52.5065 415.421C52.5723 398.401 50.188 357.487 27.4803 334.777C26.5595 333.856 25.5894 332.952 24.6028 332.08Z",
    fill: "url(#paint10_linear_935_11)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6028 332.08C19.2917 327.476 13.3558 323.907 6.61418 321.211C6.51552 321.49 6.40042 321.77 6.30176 322.066C12.9283 324.713 18.7819 328.249 24.0108 332.771C49.1357 354.544 51.6843 397.826 51.6021 415.421C51.5692 423.824 50.9937 432.277 50.2209 440.663C50.5004 440.828 50.7964 440.976 51.0924 441.14C51.8816 432.606 52.4736 423.989 52.5065 415.421C52.5723 398.401 50.188 357.487 27.4803 334.777C26.5595 333.856 25.5894 332.952 24.6028 332.08Z",
    fill: "url(#paint11_linear_935_11)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6209 325.864C24.4877 320.717 17.4995 316.902 9.42596 314.271C9.29441 314.551 9.17931 314.83 9.06421 315.11C17.0555 317.724 23.9615 321.474 30.029 326.571C55.7951 348.18 58.3109 391.725 58.2123 409.452C58.1465 420.897 57.0941 432.408 55.8938 443.706C56.1898 443.854 56.4693 443.985 56.7653 444.133C57.9985 432.704 59.0673 421.045 59.1331 409.452C59.2317 392.448 56.9132 351.863 34.2219 329.17C33.0709 328.019 31.887 326.933 30.6374 325.881L30.6209 325.864Z",
    fill: "url(#paint12_linear_935_11)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6209 325.864C24.4877 320.717 17.4995 316.902 9.42596 314.271C9.29441 314.551 9.17931 314.83 9.06421 315.11C17.0555 317.724 23.9615 321.474 30.029 326.571C55.7951 348.18 58.3109 391.725 58.2123 409.452C58.1465 420.897 57.0941 432.408 55.8938 443.706C56.1898 443.854 56.4693 443.985 56.7653 444.133C57.9985 432.704 59.0673 421.045 59.1331 409.452C59.2317 392.448 56.9132 351.863 34.2219 329.17C33.0709 328.019 31.887 326.933 30.6374 325.881L30.6209 325.864Z",
    fill: "url(#paint13_linear_935_11)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6228 319.632C29.7825 314.074 21.9228 310.143 12.6818 307.66C12.5338 307.94 12.3694 308.203 12.2214 308.483C21.4295 310.933 29.2563 314.83 36.0473 320.339C62.4382 341.733 64.954 385.574 64.8225 403.45C64.7074 417.542 63.1288 431.783 61.5832 445.548C61.5503 445.794 61.5339 446.024 61.501 446.271C61.797 446.386 62.0765 446.534 62.3725 446.649C62.4054 446.32 62.4382 445.975 62.4875 445.646C64.0332 431.849 65.6117 417.592 65.7268 403.45C65.8584 386.479 63.5892 346.173 40.9144 323.513C39.5496 322.148 38.1191 320.865 36.6228 319.632Z",
    fill: "url(#paint14_linear_935_11)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6228 319.632C29.7825 314.074 21.9228 310.143 12.6818 307.66C12.5338 307.94 12.3694 308.203 12.2214 308.483C21.4295 310.933 29.2563 314.83 36.0473 320.339C62.4382 341.733 64.954 385.574 64.8225 403.45C64.7074 417.542 63.1288 431.783 61.5832 445.548C61.5503 445.794 61.5339 446.024 61.501 446.271C61.797 446.386 62.0765 446.534 62.3725 446.649C62.4054 446.32 62.4382 445.975 62.4875 445.646C64.0332 431.849 65.6117 417.592 65.7268 403.45C65.8584 386.479 63.5892 346.173 40.9144 323.513C39.5496 322.148 38.1191 320.865 36.6228 319.632Z",
    fill: "url(#paint15_linear_935_11)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6409 313.416C35.2251 307.594 26.609 303.664 16.3979 301.378C16.2335 301.642 16.0526 301.921 15.8882 302.184C26.1157 304.437 34.6989 308.335 42.0818 314.123C69.0812 335.32 71.6134 379.457 71.4325 397.464C71.301 411.474 69.706 425.617 68.1768 439.299C67.8315 442.341 67.5027 445.399 67.1738 448.475C67.4698 448.573 67.7657 448.656 68.0453 448.754C68.3741 445.646 68.7194 442.538 69.0812 439.397C70.6268 425.699 72.2053 411.524 72.3533 397.464C72.5177 380.509 70.298 340.5 47.656 317.856C46.0939 316.294 44.4167 314.797 42.6573 313.416H42.6409Z",
    fill: "url(#paint16_linear_935_11)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6409 313.416C35.2251 307.594 26.609 303.664 16.3979 301.378C16.2335 301.642 16.0526 301.921 15.8882 302.184C26.1157 304.437 34.6989 308.335 42.0818 314.123C69.0812 335.32 71.6134 379.457 71.4325 397.464C71.301 411.474 69.706 425.617 68.1768 439.299C67.8315 442.341 67.5027 445.399 67.1738 448.475C67.4698 448.573 67.7657 448.656 68.0453 448.754C68.3741 445.646 68.7194 442.538 69.0812 439.397C70.6268 425.699 72.2053 411.524 72.3533 397.464C72.5177 380.509 70.298 340.5 47.656 317.856C46.0939 316.294 44.4167 314.797 42.6573 313.416H42.6409Z",
    fill: "url(#paint17_linear_935_11)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3482 312.166C52.5723 310.39 50.6814 308.729 48.6424 307.183C40.7827 301.214 31.6075 297.317 20.6236 295.278C20.4263 295.541 20.2125 295.804 19.9988 296.067H20.0317C31.0649 298.073 40.2401 301.938 48.0834 307.89C75.7569 328.874 78.2233 373.323 78.026 391.445C77.8616 405.374 76.2666 419.434 74.7374 433.033C74.0961 438.739 73.4549 444.479 72.8958 450.251C73.1918 450.333 73.4878 450.415 73.7673 450.481C74.3099 444.758 74.9676 438.97 75.6254 433.132C77.171 419.516 78.766 405.423 78.914 391.445C79.1113 374.507 76.9408 334.761 54.3317 312.133L54.3482 312.166Z",
    fill: "url(#paint18_linear_935_11)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3482 312.166C52.5723 310.39 50.6814 308.729 48.6424 307.183C40.7827 301.214 31.6075 297.317 20.6236 295.278C20.4263 295.541 20.2125 295.804 19.9988 296.067H20.0317C31.0649 298.073 40.2401 301.938 48.0834 307.89C75.7569 328.874 78.2233 373.323 78.026 391.445C77.8616 405.374 76.2666 419.434 74.7374 433.033C74.0961 438.739 73.4549 444.479 72.8958 450.251C73.1918 450.333 73.4878 450.415 73.7673 450.481C74.3099 444.758 74.9676 438.97 75.6254 433.132C77.171 419.516 78.766 405.423 78.914 391.445C79.1113 374.507 76.9408 334.761 54.3317 312.133L54.3482 312.166Z",
    fill: "url(#paint19_linear_935_11)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0732 306.476C59.1001 304.503 56.9625 302.645 54.6605 300.951C46.4719 294.932 37.2967 291.265 25.8031 289.39C25.688 289.374 25.5729 289.358 25.4578 289.341C25.2276 289.604 24.9974 289.884 24.7507 290.163C25.0467 290.213 25.3591 290.246 25.6551 290.295C37.0172 292.137 46.0608 295.754 54.1343 301.691C82.4162 322.477 84.8991 367.206 84.6524 385.476C84.4716 399.322 82.8766 413.3 81.331 426.817C80.3937 435.056 79.4565 443.377 78.8316 451.731C79.1276 451.796 79.4071 451.862 79.7031 451.928C80.3279 443.706 81.2652 435.385 82.2353 426.932C83.781 413.382 85.3759 399.388 85.5568 385.492C85.787 368.571 83.6823 329.071 61.0897 306.476H61.0732Z",
    fill: "url(#paint20_linear_935_11)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0732 306.476C59.1001 304.503 56.9625 302.645 54.6605 300.951C46.4719 294.932 37.2967 291.265 25.8031 289.39C25.688 289.374 25.5729 289.358 25.4578 289.341C25.2276 289.604 24.9974 289.884 24.7507 290.163C25.0467 290.213 25.3591 290.246 25.6551 290.295C37.0172 292.137 46.0608 295.754 54.1343 301.691C82.4162 322.477 84.8991 367.206 84.6524 385.476C84.4716 399.322 82.8766 413.3 81.331 426.817C80.3937 435.056 79.4565 443.377 78.8316 451.731C79.1276 451.796 79.4071 451.862 79.7031 451.928C80.3279 443.706 81.2652 435.385 82.2353 426.932C83.781 413.382 85.3759 399.388 85.5568 385.492C85.787 368.571 83.6823 329.071 61.0897 306.476H61.0732Z",
    fill: "url(#paint21_linear_935_11)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3547 300.408C65.25 298.303 63.0137 296.396 60.6624 294.735C52.3587 288.831 43.052 285.296 31.3775 283.618C31.2295 283.602 31.0979 283.586 30.9499 283.569C30.6704 283.849 30.3744 284.095 30.1113 284.375C30.4895 284.424 30.8677 284.457 31.2459 284.523C42.7724 286.184 51.9476 289.654 60.1362 295.475C80.2131 309.749 91.8218 341.158 91.2463 379.49C91.0326 393.254 89.4376 407.166 87.8919 420.601C86.6752 431.257 85.4255 442.045 84.8828 452.865C85.1788 452.915 85.4584 452.964 85.7544 453.013C86.3134 442.407 87.5302 431.668 88.7963 420.7C90.3419 407.232 91.9369 393.303 92.1507 379.49C92.6768 345.318 83.5346 316.573 67.3547 300.408Z",
    fill: "url(#paint22_linear_935_11)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3547 300.408C65.25 298.303 63.0137 296.396 60.6624 294.735C52.3587 288.831 43.052 285.296 31.3775 283.618C31.2295 283.602 31.0979 283.586 30.9499 283.569C30.6704 283.849 30.3744 284.095 30.1113 284.375C30.4895 284.424 30.8677 284.457 31.2459 284.523C42.7724 286.184 51.9476 289.654 60.1362 295.475C80.2131 309.749 91.8218 341.158 91.2463 379.49C91.0326 393.254 89.4376 407.166 87.8919 420.601C86.6752 431.257 85.4255 442.045 84.8828 452.865C85.1788 452.915 85.4584 452.964 85.7544 453.013C86.3134 442.407 87.5302 431.668 88.7963 420.7C90.3419 407.232 91.9369 393.303 92.1507 379.49C92.6768 345.318 83.5346 316.573 67.3547 300.408Z",
    fill: "url(#paint23_linear_935_11)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0633 294.669C71.7448 292.35 69.2784 290.295 66.6804 288.502C58.3438 282.763 48.9878 279.376 37.2968 277.879C36.9844 278.142 36.6884 278.422 36.376 278.669C36.5404 278.685 36.7049 278.702 36.8693 278.718C48.5602 280.182 57.867 283.52 66.1707 289.242C96.5737 310.176 98.1029 359.016 97.8562 373.488C97.626 387.169 96.0146 400.999 94.469 414.385C92.9727 427.327 91.4599 440.483 91.1804 453.638C91.4599 453.671 91.7559 453.671 92.0354 453.704C92.3149 440.861 93.8113 427.853 95.3569 414.5C96.9026 401.098 98.5139 387.252 98.7606 373.521C99.3525 339.464 90.2431 310.883 74.0633 294.686V294.669Z",
    fill: "url(#paint24_linear_935_11)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0633 294.669C71.7448 292.35 69.2784 290.295 66.6804 288.502C58.3438 282.763 48.9878 279.376 37.2968 277.879C36.9844 278.142 36.6884 278.422 36.376 278.669C36.5404 278.685 36.7049 278.702 36.8693 278.718C48.5602 280.182 57.867 283.52 66.1707 289.242C96.5737 310.176 98.1029 359.016 97.8562 373.488C97.626 387.169 96.0146 400.999 94.469 414.385C92.9727 427.327 91.4599 440.483 91.1804 453.638C91.4599 453.671 91.7559 453.671 92.0354 453.704C92.3149 440.861 93.8113 427.853 95.3569 414.5C96.9026 401.098 98.5139 387.252 98.7606 373.521C99.3525 339.464 90.2431 310.883 74.0633 294.686V294.669Z",
    fill: "url(#paint25_linear_935_11)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0186 289.127C78.5028 286.611 75.7404 284.309 72.6984 282.286C64.6743 276.925 55.7457 273.768 44.8111 272.337C44.4329 272.584 44.0712 272.847 43.7095 273.11C54.9565 274.442 64.0494 277.6 72.2051 283.043C103.266 303.746 104.762 352.932 104.483 367.518C104.22 381.134 102.608 394.898 101.046 408.202C99.2867 423.298 97.4944 438.657 97.6917 454C97.9712 454 98.2508 454 98.5468 454.016C98.3823 439.052 100.125 423.906 101.95 408.301C103.513 394.964 105.124 381.184 105.387 367.535C105.65 354.264 104.433 312.528 81.035 289.144L81.0186 289.127Z",
    fill: "url(#paint26_linear_935_11)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0186 289.127C78.5028 286.611 75.7404 284.309 72.6984 282.286C64.6743 276.925 55.7457 273.768 44.8111 272.337C44.4329 272.584 44.0712 272.847 43.7095 273.11C54.9565 274.442 64.0494 277.6 72.2051 283.043C103.266 303.746 104.762 352.932 104.483 367.518C104.22 381.134 102.608 394.898 101.046 408.202C99.2867 423.298 97.4944 438.657 97.6917 454C97.9712 454 98.2508 454 98.5468 454.016C98.3823 439.052 100.125 423.906 101.95 408.301C103.513 394.964 105.124 381.184 105.387 367.535C105.65 354.264 104.433 312.528 81.035 289.144L81.0186 289.127Z",
    fill: "url(#paint27_linear_935_11)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M111.981 361.532C112.26 348.245 111.109 306.739 87.7275 283.355C85.0308 280.658 82.0382 278.192 78.7167 276.054C71.416 271.334 63.3754 268.407 53.8056 266.96C53.3781 267.19 52.9671 267.437 52.5396 267.667C62.4875 269.032 70.7419 271.992 78.2235 276.81C109.942 297.3 111.389 346.815 111.077 361.5C110.797 375.05 109.169 388.732 107.607 401.986C105.585 419.088 103.529 436.552 104.368 453.934C104.664 453.934 104.976 453.901 105.272 453.885C104.434 436.585 106.489 419.154 108.511 402.101C110.074 388.83 111.701 375.116 111.981 361.532Z",
    fill: "url(#paint28_linear_935_11)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M111.981 361.532C112.26 348.245 111.109 306.739 87.7275 283.355C85.0308 280.658 82.0382 278.192 78.7167 276.054C71.416 271.334 63.3754 268.407 53.8056 266.96C53.3781 267.19 52.9671 267.437 52.5396 267.667C62.4875 269.032 70.7419 271.992 78.2235 276.81C109.942 297.3 111.389 346.815 111.077 361.5C110.797 375.05 109.169 388.732 107.607 401.986C105.585 419.088 103.529 436.552 104.368 453.934C104.664 453.934 104.976 453.901 105.272 453.885C104.434 436.585 106.489 419.154 108.511 402.101C110.074 388.83 111.701 375.116 111.981 361.532Z",
    fill: "url(#paint29_linear_935_11)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M118.574 355.547C118.887 342.26 117.785 300.951 94.4197 277.583C91.5422 274.705 88.3029 272.091 84.7019 269.838C78.7167 266.089 72.2381 263.54 64.8552 262.01C64.329 262.208 63.7864 262.405 63.2603 262.602C71.1364 264.082 77.9438 266.681 84.225 270.594C116.601 290.838 118.015 340.714 117.67 355.514C117.358 368.982 115.73 382.614 114.151 395.786C111.882 414.747 109.58 434.135 111.208 453.359C111.504 453.326 111.816 453.293 112.112 453.243C110.484 434.119 112.786 414.78 115.039 395.885C116.618 382.68 118.246 369.031 118.558 355.514L118.574 355.547Z",
    fill: "url(#paint30_linear_935_11)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M118.574 355.547C118.887 342.26 117.785 300.951 94.4197 277.583C91.5422 274.705 88.3029 272.091 84.7019 269.838C78.7167 266.089 72.2381 263.54 64.8552 262.01C64.329 262.208 63.7864 262.405 63.2603 262.602C71.1364 264.082 77.9438 266.681 84.225 270.594C116.601 290.838 118.015 340.714 117.67 355.514C117.358 368.982 115.73 382.614 114.151 395.786C111.882 414.747 109.58 434.135 111.208 453.359C111.504 453.326 111.816 453.293 112.112 453.243C110.484 434.119 112.786 414.78 115.039 395.885C116.618 382.68 118.246 369.031 118.558 355.514L118.574 355.547Z",
    fill: "url(#paint31_linear_935_11)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M125.185 349.561C125.513 336.274 124.494 295.162 101.128 271.795C98.0536 268.736 94.6006 265.957 90.7201 263.605C86.8231 261.237 82.7124 259.412 78.2892 257.998C77.6972 258.129 77.1053 258.245 76.5298 258.393C81.4627 259.823 85.9845 261.813 90.2597 264.395C123.326 284.424 124.658 334.629 124.28 349.544C123.935 362.963 122.307 376.53 120.712 389.636C118.213 410.274 115.68 431.455 118.246 452.355C118.542 452.306 118.838 452.257 119.134 452.191C116.585 431.405 119.134 410.307 121.6 389.751C123.178 376.612 124.823 363.029 125.168 349.577L125.185 349.561Z",
    fill: "url(#paint32_linear_935_11)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M125.185 349.561C125.513 336.274 124.494 295.162 101.128 271.795C98.0536 268.736 94.6006 265.957 90.7201 263.605C86.8231 261.237 82.7124 259.412 78.2892 257.998C77.6972 258.129 77.1053 258.245 76.5298 258.393C81.4627 259.823 85.9845 261.813 90.2597 264.395C123.326 284.424 124.658 334.629 124.28 349.544C123.935 362.963 122.307 376.53 120.712 389.636C118.213 410.274 115.68 431.455 118.246 452.355C118.542 452.306 118.838 452.257 119.134 452.191C116.585 431.405 119.134 410.307 121.6 389.751C123.178 376.612 124.823 363.029 125.168 349.577L125.185 349.561Z",
    fill: "url(#paint33_linear_935_11)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M131.795 343.559C132.518 316.869 126.22 284.474 107.443 265.694C104.253 262.504 100.684 259.692 96.7382 257.373C95.768 256.814 94.7979 256.288 93.8113 255.778C93.2194 255.811 92.611 255.86 92.019 255.909C93.466 256.6 94.8965 257.34 96.2942 258.146C123.096 273.85 131.745 312.544 130.907 343.526C130.545 356.879 128.901 370.38 127.306 383.453C124.593 405.587 121.83 428.347 125.398 450.711C125.694 450.629 125.99 450.547 126.27 450.481C122.751 428.264 125.497 405.604 128.194 383.568C129.789 370.478 131.449 356.961 131.811 343.559H131.795Z",
    fill: "url(#paint34_linear_935_11)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M131.795 343.559C132.518 316.869 126.22 284.474 107.443 265.694C104.253 262.504 100.684 259.692 96.7382 257.373C95.768 256.814 94.7979 256.288 93.8113 255.778C93.2194 255.811 92.611 255.86 92.019 255.909C93.466 256.6 94.8965 257.34 96.2942 258.146C123.096 273.85 131.745 312.544 130.907 343.526C130.545 356.879 128.901 370.38 127.306 383.453C124.593 405.587 121.83 428.347 125.398 450.711C125.694 450.629 125.99 450.547 126.27 450.481C122.751 428.264 125.497 405.604 128.194 383.568C129.789 370.478 131.449 356.961 131.811 343.559H131.795Z",
    fill: "url(#paint35_linear_935_11)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M138.405 337.573C139.177 310.9 132.913 278.652 114.135 259.872C112.786 258.524 111.356 257.274 109.892 256.074C109.35 256.024 108.824 255.992 108.281 255.942C130.923 273.423 138.339 308.746 137.5 337.556C137.106 350.844 135.445 364.295 133.833 377.303C130.923 400.769 127.947 424.926 132.534 448.557C132.814 448.458 133.11 448.343 133.389 448.244C128.868 424.778 131.844 400.736 134.721 377.401C136.333 364.377 137.993 350.893 138.388 337.556L138.405 337.573Z",
    fill: "url(#paint36_linear_935_11)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M138.405 337.573C139.177 310.9 132.913 278.652 114.135 259.872C112.786 258.524 111.356 257.274 109.892 256.074C109.35 256.024 108.824 255.992 108.281 255.942C130.923 273.423 138.339 308.746 137.5 337.556C137.106 350.844 135.445 364.295 133.833 377.303C130.923 400.769 127.947 424.926 132.534 448.557C132.814 448.458 133.11 448.343 133.389 448.244C128.868 424.778 131.844 400.736 134.721 377.401C136.333 364.377 137.993 350.893 138.388 337.556L138.405 337.573Z",
    fill: "url(#paint37_linear_935_11)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M144.998 331.587C145.755 307.068 140.542 277.945 125.069 258.804C124.576 258.672 124.066 258.524 123.573 258.409C139.506 277.304 144.867 306.789 144.094 331.554C143.683 344.792 142.006 358.194 140.378 371.152C137.303 395.704 134.129 421.045 139.671 445.745C139.95 445.613 140.23 445.498 140.526 445.383C135.067 420.897 138.224 395.704 141.282 371.268C142.91 358.293 144.587 344.858 144.998 331.587Z",
    fill: "url(#paint38_linear_935_11)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M144.998 331.587C145.755 307.068 140.542 277.945 125.069 258.804C124.576 258.672 124.066 258.524 123.573 258.409C139.506 277.304 144.867 306.789 144.094 331.554C143.683 344.792 142.006 358.194 140.378 371.152C137.303 395.704 134.129 421.045 139.671 445.745C139.95 445.613 140.23 445.498 140.526 445.383C135.067 420.897 138.224 395.704 141.282 371.268C142.91 358.293 144.587 344.858 144.998 331.587Z",
    fill: "url(#paint39_linear_935_11)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M151.608 325.601C152.283 305.243 148.813 281.793 138.766 263.474C138.306 263.277 137.862 263.063 137.402 262.882C147.794 281.168 151.378 304.98 150.704 325.568C150.276 338.757 148.566 352.11 146.939 365.019C143.699 390.475 140.394 416.786 146.791 442.324C147.07 442.176 147.333 442.012 147.613 441.864C141.332 416.556 144.62 390.425 147.826 365.134C149.471 352.208 151.164 338.823 151.608 325.601Z",
    fill: "url(#paint40_linear_935_11)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M151.608 325.601C152.283 305.243 148.813 281.793 138.766 263.474C138.306 263.277 137.862 263.063 137.402 262.882C147.794 281.168 151.378 304.98 150.704 325.568C150.276 338.757 148.566 352.11 146.939 365.019C143.699 390.475 140.394 416.786 146.791 442.324C147.07 442.176 147.333 442.012 147.613 441.864C141.332 416.556 144.62 390.425 147.826 365.134C149.471 352.208 151.164 338.823 151.608 325.601Z",
    fill: "url(#paint41_linear_935_11)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M151.608 325.601C152.283 305.243 148.813 281.793 138.766 263.474C138.306 263.277 137.862 263.063 137.402 262.882C147.794 281.168 151.378 304.98 150.704 325.568C150.276 338.757 148.566 352.11 146.939 365.019C143.699 390.475 140.394 416.786 146.791 442.324C147.07 442.176 147.333 442.012 147.613 441.864C141.332 416.556 144.62 390.425 147.826 365.134C149.471 352.208 151.164 338.823 151.608 325.601Z",
    fill: "url(#paint42_linear_935_11)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M154.387 359C156.048 346.108 157.758 332.787 158.235 319.599C158.794 303.483 156.755 285.477 150.918 269.608C150.507 269.361 150.096 269.131 149.685 268.884C155.785 284.885 157.906 303.204 157.331 319.566C156.87 332.705 155.16 346.009 153.499 358.868C150.194 384.571 146.758 411.162 153.417 436.931C153.532 437.358 153.647 437.769 153.762 438.197C154.026 438.032 154.305 437.868 154.568 437.703C154.486 437.375 154.387 437.046 154.289 436.7C147.679 411.096 151.099 384.604 154.387 358.984V359Z",
    fill: "url(#paint43_linear_935_11)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M154.387 359C156.048 346.108 157.758 332.787 158.235 319.599C158.794 303.483 156.755 285.477 150.918 269.608C150.507 269.361 150.096 269.131 149.685 268.884C155.785 284.885 157.906 303.204 157.331 319.566C156.87 332.705 155.16 346.009 153.499 358.868C150.194 384.571 146.758 411.162 153.417 436.931C153.532 437.358 153.647 437.769 153.762 438.197C154.026 438.032 154.305 437.868 154.568 437.703C154.486 437.375 154.387 437.046 154.289 436.7C147.679 411.096 151.099 384.604 154.387 358.984V359Z",
    fill: "url(#paint44_linear_935_11)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M160.931 352.883C162.609 340.039 164.352 326.752 164.828 313.613C165.256 301.872 164.319 289.127 161.507 276.958C161.129 276.662 160.751 276.366 160.372 276.087C163.349 288.502 164.368 301.559 163.924 313.58C163.431 326.67 161.704 339.941 160.027 352.768C156.706 378.174 153.269 404.436 159.6 429.925C159.895 431.093 160.208 432.244 160.52 433.395C160.783 433.198 161.03 433 161.293 432.803C161.014 431.783 160.734 430.747 160.471 429.711C154.173 404.387 157.61 378.207 160.915 352.883H160.931Z",
    fill: "url(#paint45_linear_935_11)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M160.931 352.883C162.609 340.039 164.352 326.752 164.828 313.613C165.256 301.872 164.319 289.127 161.507 276.958C161.129 276.662 160.751 276.366 160.372 276.087C163.349 288.502 164.368 301.559 163.924 313.58C163.431 326.67 161.704 339.941 160.027 352.768C156.706 378.174 153.269 404.436 159.6 429.925C159.895 431.093 160.208 432.244 160.52 433.395C160.783 433.198 161.03 433 161.293 432.803C161.014 431.783 160.734 430.747 160.471 429.711C154.173 404.387 157.61 378.207 160.915 352.883H160.931Z",
    fill: "url(#paint46_linear_935_11)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M167.459 346.782C169.153 333.972 170.912 320.734 171.422 307.644C171.702 300.375 171.455 292.745 170.567 285.098C170.419 284.95 170.288 284.802 170.14 284.654C169.942 284.457 169.729 284.26 169.515 284.062C170.518 292.038 170.797 300.03 170.501 307.611C169.992 320.668 168.232 333.889 166.539 346.667C163.201 371.761 159.764 397.727 165.782 422.92C166.177 424.581 166.621 426.225 167.098 427.853C167.344 427.623 167.591 427.393 167.838 427.146C167.427 425.666 167.015 424.186 166.67 422.69C160.685 397.661 164.122 371.777 167.443 346.765L167.459 346.782Z",
    fill: "url(#paint47_linear_935_11)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M167.459 346.782C169.153 333.972 170.912 320.734 171.422 307.644C171.702 300.375 171.455 292.745 170.567 285.098C170.419 284.95 170.288 284.802 170.14 284.654C169.942 284.457 169.729 284.26 169.515 284.062C170.518 292.038 170.797 300.03 170.501 307.611C169.992 320.668 168.232 333.889 166.539 346.667C163.201 371.761 159.764 397.727 165.782 422.92C166.177 424.581 166.621 426.225 167.098 427.853C167.344 427.623 167.591 427.393 167.838 427.146C167.427 425.666 167.015 424.186 166.67 422.69C160.685 397.661 164.122 371.777 167.443 346.765L167.459 346.782Z",
    fill: "url(#paint48_linear_935_11)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M174.004 340.681C175.73 327.903 177.506 314.699 178.049 301.642C178.147 299.043 178.18 296.379 178.131 293.682C177.818 293.288 177.522 292.877 177.21 292.482C177.292 295.59 177.259 298.649 177.144 301.609C176.602 314.616 174.826 327.805 173.116 340.566C169.778 365.364 166.325 391.001 172.03 415.898C172.458 417.773 172.951 419.631 173.477 421.489C173.724 421.226 173.954 420.947 174.184 420.683C173.724 419.039 173.28 417.378 172.902 415.701C167.229 390.952 170.682 365.397 174.004 340.681Z",
    fill: "url(#paint49_linear_935_11)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M174.004 340.681C175.73 327.903 177.506 314.699 178.049 301.642C178.147 299.043 178.18 296.379 178.131 293.682C177.818 293.288 177.522 292.877 177.21 292.482C177.292 295.59 177.259 298.649 177.144 301.609C176.602 314.616 174.826 327.805 173.116 340.566C169.778 365.364 166.325 391.001 172.03 415.898C172.458 417.773 172.951 419.631 173.477 421.489C173.724 421.226 173.954 420.947 174.184 420.683C173.724 419.039 173.28 417.378 172.902 415.701C167.229 390.952 170.682 365.397 174.004 340.681Z",
    fill: "url(#paint50_linear_935_11)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M184.215 302.349C183.935 301.905 183.672 301.477 183.392 301.033C182.636 312.232 181.14 323.513 179.643 334.465C176.289 358.951 172.82 384.259 178.229 408.876C178.624 410.636 179.068 412.379 179.528 414.122C179.759 413.81 179.989 413.514 180.219 413.201C179.824 411.705 179.446 410.192 179.117 408.679C173.757 384.226 177.21 358.984 180.548 334.58C181.995 324.023 183.442 313.169 184.215 302.349Z",
    fill: "url(#paint51_linear_935_11)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M184.215 302.349C183.935 301.905 183.672 301.477 183.392 301.033C182.636 312.232 181.14 323.513 179.643 334.465C176.289 358.951 172.82 384.259 178.229 408.876C178.624 410.636 179.068 412.379 179.528 414.122C179.759 413.81 179.989 413.514 180.219 413.201C179.824 411.705 179.446 410.192 179.117 408.679C173.757 384.226 177.21 358.984 180.548 334.58C181.995 324.023 183.442 313.169 184.215 302.349Z",
    fill: "url(#paint52_linear_935_11)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M189.295 311.574C189.065 311.081 188.819 310.587 188.572 310.111C187.849 316.261 187.01 322.378 186.171 328.397C182.801 352.57 179.331 377.566 184.428 401.871C184.691 403.104 184.971 404.338 185.267 405.554C185.497 405.176 185.711 404.782 185.925 404.403C185.711 403.499 185.497 402.594 185.3 401.674C180.235 377.517 183.705 352.603 187.059 328.512C187.832 322.937 188.605 317.264 189.295 311.574Z",
    fill: "url(#paint53_linear_935_11)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M189.295 311.574C189.065 311.081 188.819 310.587 188.572 310.111C187.849 316.261 187.01 322.378 186.171 328.397C182.801 352.57 179.331 377.566 184.428 401.871C184.691 403.104 184.971 404.338 185.267 405.554C185.497 405.176 185.711 404.782 185.925 404.403C185.711 403.499 185.497 402.594 185.3 401.674C180.235 377.517 183.705 352.603 187.059 328.512C187.832 322.937 188.605 317.264 189.295 311.574Z",
    fill: "url(#paint54_linear_935_11)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M192.699 322.312C189.328 346.157 185.826 370.824 190.644 394.849C190.644 394.915 190.677 394.997 190.693 395.063C190.907 394.57 191.121 394.076 191.334 393.583C186.878 370.051 190.282 345.861 193.604 322.444C193.62 322.296 193.653 322.148 193.669 322C193.456 321.408 193.225 320.816 192.995 320.224C192.896 320.915 192.798 321.622 192.699 322.312Z",
    fill: "url(#paint55_linear_935_11)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M192.699 322.312C189.328 346.157 185.826 370.824 190.644 394.849C190.644 394.915 190.677 394.997 190.693 395.063C190.907 394.57 191.121 394.076 191.334 393.583C186.878 370.051 190.282 345.861 193.604 322.444C193.62 322.296 193.653 322.148 193.669 322C193.456 321.408 193.225 320.816 192.995 320.224C192.896 320.915 192.798 321.622 192.699 322.312Z",
    fill: "url(#paint56_linear_935_11)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M197.451 336.142C197.27 335.221 197.073 334.317 196.876 333.412C194.919 349.133 193.785 365.035 195.758 380.756C195.971 379.983 196.202 379.21 196.383 378.437C194.87 364.41 195.791 350.219 197.451 336.142Z",
    fill: "url(#paint57_linear_935_11)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M197.451 336.142C197.27 335.221 197.073 334.317 196.876 333.412C194.919 349.133 193.785 365.035 195.758 380.756C195.971 379.983 196.202 379.21 196.383 378.437C194.87 364.41 195.791 350.219 197.451 336.142Z",
    fill: "url(#paint58_linear_935_11)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M413.607 196.175C455.474 154.304 455.474 86.4172 413.607 44.5459C371.739 2.67459 303.859 2.6746 261.991 44.5459C220.124 86.4172 220.124 154.304 261.991 196.175C303.859 238.047 371.739 238.047 413.607 196.175Z",
    fill: "url(#paint59_linear_935_11)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_935_11",
    x1: -43.0436,
    y1: 329.367,
    x2: 104.943,
    y2: 502.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_935_11",
    x1: 2.53638,
    y1: 390.52,
    x2: 15.77,
    y2: 390.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_935_11",
    x1: -39.9522,
    y1: 326.719,
    x2: 108.051,
    y2: 499.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_935_11",
    x1: 0.842773,
    y1: 389.322,
    x2: 25.6137,
    y2: 389.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_935_11",
    x1: -36.4334,
    y1: 323.71,
    x2: 111.553,
    y2: 496.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_935_11",
    x1: 1.073,
    y1: 387.867,
    x2: 33.2668,
    y2: 387.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_935_11",
    x1: -32.6516,
    y1: 320.454,
    x2: 115.351,
    y2: 493.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_935_11",
    x1: 2.25684,
    y1: 386.231,
    x2: 40.0935,
    y2: 386.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_935_11",
    x1: -28.6723,
    y1: 317.05,
    x2: 119.314,
    y2: 489.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_935_11",
    x1: 4.03271,
    y1: 384.485,
    x2: 46.7902,
    y2: 384.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_935_11",
    x1: -24.5946,
    y1: 313.547,
    x2: 123.408,
    y2: 486.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_935_11",
    x1: 6.30176,
    y1: 382.638,
    x2: 53.4939,
    y2: 382.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_935_11",
    x1: -20.3852,
    y1: 309.946,
    x2: 127.618,
    y2: 482.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_935_11",
    x1: 9.06421,
    y1: 380.786,
    x2: 60.2045,
    y2: 380.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_935_11",
    x1: -16.0769,
    y1: 306.246,
    x2: 131.926,
    y2: 478.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_935_11",
    x1: 12.2214,
    y1: 378.85,
    x2: 66.8739,
    y2: 378.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_935_11",
    x1: -11.6538,
    y1: 302.464,
    x2: 136.349,
    y2: 475.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_935_11",
    x1: 15.8882,
    y1: 376.864,
    x2: 73.5664,
    y2: 376.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_935_11",
    x1: -7.09924,
    y1: 298.55,
    x2: 140.903,
    y2: 471.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_935_11",
    x1: 19.9988,
    y1: 374.772,
    x2: 80.1828,
    y2: 374.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_935_11",
    x1: -2.41303,
    y1: 294.538,
    x2: 145.573,
    y2: 467.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_935_11",
    x1: 24.7507,
    y1: 372.617,
    x2: 86.8701,
    y2: 372.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_935_11",
    x1: 2.3556,
    y1: 290.443,
    x2: 150.358,
    y2: 463.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_935_11",
    x1: 30.1113,
    y1: 370.358,
    x2: 93.4967,
    y2: 370.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_935_11",
    x1: 7.3377,
    y1: 286.184,
    x2: 155.34,
    y2: 458.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_935_11",
    x1: 36.376,
    y1: 367.936,
    x2: 100.12,
    y2: 367.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_935_11",
    x1: 12.5007,
    y1: 281.76,
    x2: 160.503,
    y2: 454.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_935_11",
    x1: 43.7095,
    y1: 365.393,
    x2: 106.731,
    y2: 365.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_935_11",
    x1: 17.7956,
    y1: 277.221,
    x2: 165.798,
    y2: 449.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_935_11",
    x1: 52.5396,
    y1: 362.727,
    x2: 113.281,
    y2: 362.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_935_11",
    x1: 23.2709,
    y1: 272.518,
    x2: 171.274,
    y2: 445.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_935_11",
    x1: 63.2603,
    y1: 360.018,
    x2: 119.793,
    y2: 360.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_935_11",
    x1: 28.911,
    y1: 267.684,
    x2: 176.914,
    y2: 440.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_935_11",
    x1: 76.5298,
    y1: 357.547,
    x2: 126.266,
    y2: 357.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_935_11",
    x1: 34.6989,
    y1: 262.734,
    x2: 182.685,
    y2: 435.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_935_11",
    x1: 92.019,
    y1: 355.622,
    x2: 132.7,
    y2: 355.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_935_11",
    x1: 40.6511,
    y1: 257.62,
    x2: 188.654,
    y2: 430.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_935_11",
    x1: 108.281,
    y1: 354.598,
    x2: 139.112,
    y2: 354.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_935_11",
    x1: 46.7679,
    y1: 252.39,
    x2: 194.771,
    y2: 425.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_935_11",
    x1: 123.573,
    y1: 354.361,
    x2: 145.528,
    y2: 354.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_935_11",
    x1: 52.4571,
    y1: 247.506,
    x2: 200.46,
    y2: 420.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_935_11",
    x1: 137.402,
    y1: 354.791,
    x2: 151.994,
    y2: 354.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_935_11",
    x1: 137.402,
    y1: 354.791,
    x2: 151.994,
    y2: 354.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_935_11",
    x1: 57.4561,
    y1: 243.231,
    x2: 205.442,
    y2: 415.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_935_11",
    x1: 149.611,
    y1: 355.605,
    x2: 158.51,
    y2: 355.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_935_11",
    x1: 61.8458,
    y1: 239.465,
    x2: 209.832,
    y2: 412.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_935_11",
    x1: 156.057,
    y1: 356.659,
    x2: 165.116,
    y2: 356.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_935_11",
    x1: 65.7269,
    y1: 236.143,
    x2: 213.713,
    y2: 408.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_935_11",
    x1: 162.487,
    y1: 357.711,
    x2: 171.725,
    y2: 357.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_935_11",
    x1: 69.1958,
    y1: 233.15,
    x2: 217.198,
    y2: 405.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_935_11",
    x1: 168.984,
    y1: 358.559,
    x2: 178.349,
    y2: 358.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_935_11",
    x1: 72.4356,
    y1: 230.388,
    x2: 220.438,
    y2: 403.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_935_11",
    x1: 175.415,
    y1: 358.957,
    x2: 184.402,
    y2: 358.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_935_11",
    x1: 75.461,
    y1: 227.789,
    x2: 223.464,
    y2: 400.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_935_11",
    x1: 181.849,
    y1: 358.996,
    x2: 189.454,
    y2: 358.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_935_11",
    x1: 78.3878,
    y1: 225.273,
    x2: 226.391,
    y2: 397.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_935_11",
    x1: 188.28,
    y1: 358.556,
    x2: 193.784,
    y2: 358.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_935_11",
    x1: 81.2488,
    y1: 222.823,
    x2: 229.235,
    y2: 395.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_935_11",
    x1: 194.728,
    y1: 357.662,
    x2: 197.509,
    y2: 357.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_935_11",
    x1: 430.491,
    y1: -33.3718,
    x2: 329.353,
    y2: 134.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundsCoin);
export default __webpack_public_path__ + "static/media/rounds-coin.74b996ce43f5c59ebb80b555124b2230.svg";
export { ForwardRef as ReactComponent };